import { getProfilePreview } from '~publish/components/Composer/components/ChannelPostPreview/getProfilePreview'
import type { InstagramPreviewProfile } from '~publish/components/Composer/InstagramPreview/types'
import { getGuestNetworkService } from '~publish/helpers/guestNetworks'
import type {
  GuestNetwork,
  GuestNetworkId,
} from '~publish/helpers/guestNetworks'
import { DEFAULT_AVATAR } from '~publish/legacy/composer/composer/components/post-preview/previews/Common/utils'
import type { DraftPreview } from '~publish/legacy/composer/composer/components/post-preview/previews/types'
import type { Image } from '~publish/legacy/composer/composer/entities/factories'
import { createPreviewProfile } from '~publish/legacy/composer/composer/utils/ProfileUtils'

type GuestIdentity = Partial<
  Pick<InstagramPreviewProfile, 'username' | 'formattedUsername'>
>

const GUEST_IDENTITIES: Partial<Record<GuestNetworkId, GuestIdentity>> = {
  x: { formattedUsername: '@buffer' },
  bluesky: { formattedUsername: '@buffer.bsky.social' },
  mastodon: { username: 'buffer@mastodon.social' },
  'facebook-page': { username: 'Buffer' },
  pinterest: { username: 'Buffer' },
  googlebusiness: { username: 'Buffer' },
}

export function buildGuestProfilePreview(
  network: GuestNetwork,
): InstagramPreviewProfile {
  const service = getGuestNetworkService(network)

  return {
    ...getProfilePreview(createPreviewProfile(service, DEFAULT_AVATAR)),
    ...GUEST_IDENTITIES[network.id],
    channelId: network.id,
    serviceType: network.id === 'facebook-page' ? 'page' : service,
  }
}

export function buildGuestDraftPreview({
  text,
  images,
}: {
  text: string
  images: readonly Image[]
}): DraftPreview {
  return {
    isEmpty: text.trim().length === 0 && images.length === 0,
    text,
    service: { isOmni: false },
    updateType: null,
    enabledAttachmentType: images.length > 0 ? 'MEDIA' : null,
    images: [...images],
    gif: null,
    video: null,
    link: null,
    assets: null,
    isReminder: false,
    isAiGenerated: false,
    hasThread: false,
    activeThreadId: null,
    thread: null,
    annotations: [],
    entities: null,
    title: null,
  }
}
